export default Object.freeze({
  Development: 0,
  Testing: 1,
  Production: 2,
});
